import React, { useState } from "react";
import ServiceHero from "./ServiceHero/ServiceHero";
import ServiceAbout from "./ServiceAbout/ServiceAbout";
import WhatWeDeliver from "./WhatWeDeliver/WhatWeDeliver";
import OurInsight from "./OurInsight/OurInsight";
import BusinessImpact from "./BusinessImpact/BusinessImpact";
import ServiceCTA from "./ServiceCTA/ServiceCTA";
import "./StandardServicePage.css";

const StandardServicePage = (props) => {
  const {
    hero = {},
    about = {},
    whatWeDeliver = {},
    ourInsight = {},
    businessImpact = {}
  } = props;

  const [formData, setFormData] = useState({
    institutionName: "",
    contactPerson: "",
    designation: "",
    email: "",
    mobile: "",
    whatsapp: "",
    city: "",
    state: "",
    serviceRequired: hero.serviceName || "Institutional Advisory",
    details: "",
    preferredTime: "Morning (09:00 AM - 12:00 PM)"
  });

  const [formSubmitted, setFormSubmitted] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    console.log("Institutional Lead Submitted:", formData);
    setFormSubmitted(true);
    setTimeout(() => {
      setFormSubmitted(false);
      setFormData({
        institutionName: "",
        contactPerson: "",
        designation: "",
        email: "",
        mobile: "",
        whatsapp: "",
        city: "",
        state: "",
        serviceRequired: hero.serviceName || "Institutional Advisory",
        details: "",
        preferredTime: "Morning (09:00 AM - 12:00 PM)"
      });
    }, 5000);
  };

  return (
    <div className="nutrivio-standard-service-page">
      {/* 1. SERVICE HERO */}
      <ServiceHero {...hero} />

      {/* 2. ABOUT THIS SERVICE & 4 PILLARS */}
      <ServiceAbout {...about} />

      {/* 3. WHAT WE DELIVER (6 CARDS) */}
      <WhatWeDeliver {...whatWeDeliver} />

      {/* 4. BUSINESS & INSTITUTIONAL IMPACT (4 TEAL CARDS) */}
      <BusinessImpact {...businessImpact} />

      {/* 5. OUR INSIGHT (LEFT IMAGE 0-RADIUS + RIGHT NARRATIVE) */}
      <OurInsight {...ourInsight} />


      {/* 6. SERVICE CALL TO ACTION BANNER */}
      <ServiceCTA />

    </div>
  );
};

export default StandardServicePage;